import { render } from "./LoaderComponent.vue?vue&type=template&id=d938a490"
const script = {}

import "./LoaderComponent.vue?vue&type=style&index=0&id=d938a490&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__